<template>
  <div class="load-hide">
    <div class="recharge_types card_choose">
      <div class="vip_card"><img src="../../../assets/img/vip.png"></div>
      <div class="vip_p"><img src="../../../assets/img/context_img.png"></div>
      <div class="vip_input">
        <div><input class="ol_card" type="button" value="线上办卡" @click="goOnline"></div>
        <div><input class="r_card" type="button" value="绑定会员卡" @click="goMain"></div>
      </div>
    </div>
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
export default {
  data(){
      return{

      }
  },
  mounted(){
  },
  methods: {
    goOnline(){
        router.push('card_online');
    },
    goMain(){
      router.push('card_bind');
    }
  }

}

</script>

<style>
  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .include-text p{
    margin: 0.1rem 0;
    font-size: 0.13rem;
  }
  .include-text div{
    margin-top: 0.2rem;
  }
  .include-text img{
    width: 200px;
  }

  .include-text input{
    border: 0px;
    background: #3d9946;
    color: #FFF;
    width: 0.875rem;
    height: 0.235rem;
    border-radius: 0.01rem;
  }
  .relieve input{
    width: 0.495rem;
    height: 0.21rem;
    line-height: 0.1rem;
    border: 0px;
    background: #50a200;
    color: #fff;
    border-radius: 0.1rem;
  }
  .recharge-recode input{
    width: 0.63rem;
    height: 0.2rem;
    line-height: 0.1rem;
    border: 0px;
    background: #fff;
    color: #727272;
    border-radius: 0.1rem;
    text-align: center;
  }
  .recharge_types.card_choose{
    background: #eff3f6;
  }
  .vip_card{
    padding:0.22rem 0.4rem 0.15rem;
  }
  .vip_card img{
    width: 100%;
  }
  .vip_p{
    padding:0.15rem 0.4rem 0.22rem;
  }
  .vip_p img{
    width: 100%;
  }
  .vip_input{
    padding: 0 0.15rem;
  }
  .vip_input input {
    width: 100%;
    height: 0.35rem;
    border: 0;
    border-radius: 0.05rem;
    margin: 0.14rem 0 0;
    font-size: 0.14rem;
  }
  .vip_input .ol_card{
    background: #3d9946;
    color: #fff;
  }
  .vip_input .r_card{
    background: #fff;
    border:1px solid #bec0c2;
    color:#252525
  }
</style>



// WEBPACK FOOTER //
// card_choose.vue?2c62cbda